var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"text-white"},[_c('TheHeader'),_c('CartHero'),_c('ReturnHome'),_c('ServicePage'),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }